import { Component, ChangeDetectorRef, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FamilyService } from '../_services/family.service';
import { TokenStorageService } from '../_services/token-storage.service';
import { AuthService } from '../_services/auth-service.service';

@Component({
  selector: 'app-family',
  templateUrl: './family.component.html',
  styleUrls: ['./family.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, RouterLink]
})
export class FamilyComponent implements OnInit {
  code = '';
  loading = false;
  errorText = '';

  showRequestForm = false;
  requestEmail = '';
  requestLoading = false;
  requestStatus = '';
  requestIsError = false;

  constructor(
    private familyService: FamilyService,
    private tokenStorage: TokenStorageService,
    private authService: AuthService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.tokenStorage.getToken() && this.familyService.getFamilyId()) {
      this.router.navigate(['/list']);
    }
  }

  submit() {
    if (!this.code.trim()) return;
    this.loading   = true;
    this.errorText = '';

    this.familyService.findFamily(this.code).subscribe({
      next: (data) => {
        try {
          const result = JSON.parse(data);
          if (result.error) {
            this.errorText = 'Familiecode niet gevonden. Controleer de code en probeer opnieuw.';
            this.loading   = false;
          } else {
            this.familyService.storeFamilyId(result.id, result.name, this.code.trim());
            this.router.navigate(['/login']);
          }
        } catch {
          this.errorText = 'Onverwacht antwoord van de server. Probeer opnieuw.';
          this.loading   = false;
        }
        this.cdr.detectChanges();
      },
      error: () => {
        this.errorText = 'Verbindingsfout. Controleer je internet en probeer opnieuw.';
        this.loading   = false;
        this.cdr.detectChanges();
      }
    });
  }

  requestCode() {
    if (!this.requestEmail.trim()) return;
    this.requestLoading = true;
    this.requestStatus  = '';

    this.authService.requestFamilyCode(this.requestEmail.trim()).subscribe({
      next: (response) => {
        const result = JSON.parse(response);
        this.requestStatus  = result.message;
        this.requestIsError = !result.success;
        this.requestLoading = false;
        if (result.success) this.requestEmail = '';
        this.cdr.markForCheck();
      },
      error: () => {
        this.requestStatus  = 'Er is een fout opgetreden. Probeer opnieuw.';
        this.requestIsError = true;
        this.requestLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  toggleRequestForm() {
    this.showRequestForm = !this.showRequestForm;
    this.requestStatus   = '';
    this.requestEmail    = '';
  }
}
